
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

window.addEventListener('frame-ready', init)

function init() {

    if(document.body.classList.contains('BrandHistory')) {

        let bread = document.querySelector('.bread')
        let bowl = document.querySelector('.bowl')
        let glove = document.querySelector('.glove')

        gsap.set(bread, { left: '-100%' })
        gsap.set(bowl, { left: '-100%' })
        gsap.set(glove, {right: '-100%' })

        gsap.timeline({
            scrollTrigger: {
                trigger: document.querySelector('.story-section--inner'),
                start: 'bottom center',
                end: '200% center',
                toggleActions: 'play reverse play reverse',
            }
        }).to(bread, { left: '-25%', rotate: '360deg' })

        gsap.timeline({
            scrollTrigger: {
                trigger: document.querySelector('.cook-book-foot'),
                start: 'top center',
                end: 'bottom-=30% center',
                toggleActions: 'play reverse play reverse',
            }
        }).to(glove, { right: '-10%', rotate: '360deg' })
    }
}